var path = 'visualizer/js/modules/core/archivePill/archivePill.tpl.html';
var html = "<aclui-pill class=archive-pill re-in-size=\"'small'\"> <acl-localize key=_App.Nav.Archived_></acl-localize> </aclui-pill> ";
window.angular.module('templates-visualizer').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;